/**
 * @generated SignedSource<<db0271b68c0f16063da32084772f3455>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PermissionFlag_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FeatureFlag_user" | "RoleFlag_user">;
  readonly " $fragmentType": "PermissionFlag_user";
};
export type PermissionFlag_user$key = {
  readonly " $data"?: PermissionFlag_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PermissionFlag_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PermissionFlag_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FeatureFlag_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoleFlag_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "80951bf245d0b37dc0493b78d3c8d52f";

export default node;
